<script setup>
import { useRoute } from 'vue-router';
import AppLayout from './components/layout/AppLayout.vue';
import ErrorBoundary from './components/common/ErrorBoundary.vue';

const route = useRoute();
</script>

<template>
  <ErrorBoundary>
    <template v-if="['/login', '/signup', '/forgot-password', '/reset-password', '/docs', '/privacy', '/terms', '/onboarding', '/style-guide', '/workspace-not-found'].includes(route.path) || route.path.startsWith('/confirm/') || route.path.startsWith('/unsubscribe/')">
      <router-view />
    </template>
    <AppLayout v-else>
      <router-view />
    </AppLayout>
  </ErrorBoundary>
</template>

<style>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&family=Inter:wght@400;500;600;700&display=swap');
</style>
